import { appendLocaleSources } from './hooks/useTranslate'

appendLocaleSources({
  dimension: {
    VOLUME: {
      humanize: [
        'м³',
        'тыс.м³',
        'млн.м³',
        'млрд.м³',
        'трлн.м³',
      ],
    },
    TEMPERATURE: {
      humanize: [
        '°C',
        'тыс.°C',
        'млн.°C',
        'млрд.°C',
        'трлн.°C',
      ],
    },
    PRESSURE: {
      humanize: [
        'кГс/см²',
        'тыс.кГс/см²',
        'млн.кГс/см²',
        'млрд.кГс/см²',
        'трлн.кГс/см²',
      ],
    },
    TILT: {
      humanize: [
        '°',
        'тыс.°',
        'млн.°',
        'млрд.°',
        'трлн.°',
      ],
    },
  },
  productionPage: {
    table: {
      type: 'Месторождение',
      name: 'Название',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
    },
  },
  productionLabels: {
    hourlyProduction: 'Часовая добыча',
    dailyProduction: 'Дневная добыча',
    monthlyProduction: 'Месячная добыча',
    yearlyProduction: 'Годовая добыча',
    operatingFactor: 'Коэффициент эксплуатации',
    wellFund: 'Фонд скважин',
    totalFund: 'Общий фонд',
    active: 'действующие',
    blowing: 'Продувка',
    control: 'Контроль',
    static: 'Статика',
    downtime: 'Простой',
    maintenance: 'Ремонт',
    drilling: 'Бурение',
    liquidation: 'Ликвидация',
  },
  time: {
    per: {
      year: 'год',
      month: 'месяц',
      day: 'день',
      hour: 'час',
      minute: 'минуту',
      second: 'секунду',
    },
  },
  type: {
    node: {
      ORGANIZATION: 'Организация',
      FACTORY: 'Завод',
      COLLECTION_POINT: 'Сборочный пункт',
      WELL: 'Скважина',
      HOLE: 'Скважине',
      FIELD: 'Месторождение',
      PLATFORM: 'Платформа',
    },
    sensor: {
      TEMPERATURE: 'Температура',
      TILT: 'Наклон',
      VOLUME: 'Объем',
      PRESSURE: 'Давление',
      PRESSURE_INPUT: 'Давление на входе',
      PRESSURE_OUTPUT: 'Давление на выходе',
      PRESSURE_WELL: 'Давление в скважине',
      PRESSURE_PLUME: 'Давление в шлейфе',
      FLOW_RATE: 'Расход',
    },
    pressure: {
      input: 'входе',
      output: 'выходе',
      plume: 'шлейфе',
      at: 'на',
      and: 'и',
      in: 'в',
    },
  },
  status: {
    sensor: {
      WORKING: 'Работает',
      NO_SIGNAL: 'Нет сигнала',
      SHORT_CIRCUIT: 'Короткое замыкание',
      TECH_WORKS: 'Техобслуживание',
      NO_SENSOR_SIGNAL: 'Не подключен датчик',
      PLUME_PRESSURE_EXCESS: 'Избыточное давление в шлейфе',
      UNDER_LIMIT: 'Нарушен нижний порог',
      OVER_LIMIT: 'Превышен верхний порог',
      ABNORMAL_VALUE: 'Аномальное показание',
      CRITICAL_VALUE: 'Критическое показание',
      CALIBRATION_REQUIRED: 'Требуется калибровка',
      UNKNOWN_UNIT: "Неизвестная единица измерения",
      INVALID_DRIVER: 'Некорректный драйвер',
    },
    node: {
      WORKING: 'Работает',
      BLOWING: 'Продувка',
      DOWNTIME: 'Простой',
      TECH_WORKS: 'Техобслуживание',
      STATIC: 'Статическое состояние',
      CONTROL: 'Контроль',
      LIQUIDATION: 'Ликвидация',
      DRILLING: 'Бурение',
      MAINTENANCE: 'Ремонт',
    },
  },
  crud: {
    add: 'Добавить',
    addItem: 'Добавить ',
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  modal: {
    editWellStatusModal: {
      title: 'Редактировать статус скважины',
      close: 'Закрыть',
      apply: 'Применить',
      wellStatusPlaceholder: 'Статус скважины',
    },
  },
  wellInfo: {
    status: 'Статус скважины',
    technicalInfo: 'Техническая информация',
    pipelineDiameter: 'Диаметр шлейфа',
    pipelineLength: 'Длина шлейфа',
    pipelineThickness: 'Толщина трубы',
    responsiblePersons: 'Ответственные лица',
    instantaneousFlowRate: 'Мгновенный расход скважины',
    unit: 'ед.',
  },
  summary: {
    ORGANIZATION: 'Сводные данные по организации "${name}"',
    FACTORY: 'Сводные данные по заводу "${name}"',
    COLLECTION_POINT: 'Сводные данные по сборочному пункту "${name}"',
    WELL: 'Сводные данные по скважине "${name}"',
    FIELD: 'Сводные данные по месторождению "${name}"',
    DEFAULT: 'Сводные данные по объекту "${name}"',
  },
  averagePressure: {
    daily: 'Среднесуточное давление:',
    monthly: 'Среднемесячное давление:',
    yearly: 'Среднегодовое давление:',
  },
  averageTemperature: {
    daily: "Среднесуточная температура:",
    monthly: "Среднемесячная температура:",
    yearly: "Среднегодовая температура:",
  },
  sensorInfo: {
    modalTitle: 'Информация о датчике ${title}',
    lastData: 'Последние данные',
    lastReading: 'Последние показания',
    lastEventAt: 'Последнее событие',
    sensorState: 'Состояние датчика',
    interval: 'Интервал',
    voltage: 'Напряжение',
    uptime: 'Время работы',
    sensorStatus: 'Статус датчика',
    mainInfo: 'Основная информация',
    devEUI: 'DevEUI',
    createdAt: 'Создано',
    serialNumber: 'Серийный номер',
    fabricator: 'Производитель',
    verificationDate: 'Дата ввода в эксплуатацию',
    verificationExpire: 'Дата окончания поверки',
    noData: 'Нет данных',
    close: 'Закрыть',
  },
  chart: {
    "pressurePlume": "Давление в шлейфе",
    "pressureWell": "Давление в скважине",
    "temperature": "Температура",
    "time": "Время",
    "pressureUnit": "Давление (Кгс/см²)",
    "temperatureUnit": "Температура (°C)",
  },
  dateChart: {
    "datePlaceholder": {
      'from': "Дата от",
      'to': "Дата до",
    },
    "apply": "Применить",
  },
  model: {
    createManufacturer: 'Создать производителя',
    manufacturerName: 'Название',
    create: 'Создать',
    cancel: 'Отмена',
    apply: 'Применить',
    delete: 'Удалить',
    close: 'Закрыть',
    edit: 'Редактировать',
    modelTitle: 'Модель',
    models: 'Модели',
    unnamed: 'Без имени',
    deleteConfirmation: 'Вы уверены, что хотите удалить эту модель?',
    unsavedChangesTitle: 'Несохраненные изменения',
    unsavedChangesMessage: 'У вас есть несохраненные изменения. Хотите продолжить без сохранения?',
    reset: 'Сброс',
    executeTests: 'Запустить тесты',
    save: 'Сохранить',
    jsonResult: 'Здесь будет ваш JSON-результат',
    testResults: 'Здесь будет ваш результат тестирования',
    testSuccess: 'Тесты успешно пройдены',
    testFail: 'Ошибка тестирования',
    modelDetails: 'Детали модели',
    validityDays: 'Срок действия (дней)',
    driverFunction: 'Функция драйвера',
    sourceCode: 'Исходный код',
    selectManufacturer: 'Выбрать производителя',
    selectModel: 'Выбрать модель',
    modelList: 'Список моделей',
    addModel: 'Добавить модель',
    successSave: 'Сохранение успешно',
    errorSave: 'Ошибка сохранения',
    manufacturerCreated: 'Производитель создан',
    saveSuccessTitle: 'Сохранение успешно',
    saveSuccessSubtitle: 'Модель успешно сохранена.',
    saveErrorTitle: 'Ошибка сохранения',
    saveErrorSubtitle: 'Не удалось сохранить модель. Ошибка:',
    deleteSuccess: "Модель успешно удалена",
    deleteError: "Ошибка при удалении модели",
  },
  uploadExcel: {
    pageTitle: 'Загрузка Excel',
    showErrorsOnly: 'Показать записи с ошибками',
    fileUpload: 'Загрузить файл',
    devEUI: 'DevEUI',
    appKey: 'Ключ приложения',
    devAddr: 'Адрес устройства',
    limits_max: 'Макс. предел',
    limits_min: 'Мин. предел',
    name: 'Имя',
    status: 'Статус',
    thresholds_critical_max: 'Макс. критический порог',
    thresholds_critical_min: 'Мин. критический порог',
    thresholds_warn_max: 'Макс. порог предупреждения',
    thresholds_warn_min: 'Мин. порог предупреждения',
    type: 'Тип',
    error: 'Ошибка',
  },
  nodes: {
    pageTitle: 'Управление узлами',
    confirmDelete: 'Вы уверены, что хотите удалить этот узел?',
    createNode: 'Создать узел',
    updateNode: 'Обновить узел',
    nodeInside: 'Создать узел внутри:',
    updateNodeInside: 'Обновить узел:',
    close: 'Закрыть',
    type: 'Тип',
    underControl: 'Под управлением',
    serverIp: 'IP адрес управляющего сервера',
    apply: 'Применить',
    create: 'Создать',
    update: 'Обновить',
    name: 'Название',
    error: 'Ошибка',
    chirpstackInstalled: 'ChirpStack установлен',
    pipeThickness: 'Толщина трубы',
    plumeLength: 'Длина шлейфа',
    plumeDiameter: 'Диаметр шлейфа',
  },
  prompt: {
    title: 'Внимание!',
    yes: 'Да',
    no: 'Нет',
    message: {
      confirmDelete: `Вы хотите удалить производителя?`,
    },
  },
  sensor: {
    modal: {
      configureInterval: 'Настроить интервал выхода',
      changeStatus: 'Изменить статус датчика',
      packageInfo: 'Информация о пакете',
      sensorEvents: 'События датчика',
      noData: 'Данные отсутствуют!',
    },
    table: {
      devEUI: 'DevEUI',
      node: 'Узел',
      serialNumber: 'Серийный номер',
      model: 'Модель',
      exitInterval: 'Интервал выхода',
      type: 'Тип',
      status: 'Статус датчика',
      createdAt: 'Дата создания',
      packages: 'Пакеты',
      edit: 'Редактировать',
      overview: 'Обзор',
      history: 'История',
      minutes: 'Мин',
      intervalPlaceholder: 'Интервал ответа в минутах',
    },
    status: {
      PENDING: 'Ожидание',
      ERROR: 'Ошибка',
      SENT: 'Успешно',
      ABANDONED: 'Заброшенный',
    },
    diff: {
      limit: 'Лимит',
      status: 'Статус',
      thresholds: 'Пороги',
      updatedAt: 'Дата обновления',
      prevMin: 'Пред. Мин:',
      prevMax: 'Пред. Макс:',
      min: 'Мин:',
      max: 'Макс:',
      prevWarn: 'Пред. Предупреждение:',
      prevCritical: 'Пред. Критический:',
      warn: 'Предупреждение:',
      critical: 'Критический:',
    },
    history: {
      value: 'Значение',
      voltage: 'Напряжение',
      type: 'Тип',
      nodeStatus: 'Статус скважины',
      sensorStatus: 'Статус датчика',
      at: 'Время',
      voltageUnit: '{value} V',
    },
    alerts: {
      noHistoryData: 'Нет данных об истории',
      fetchError: 'Ошибка при получении данных',
    },
    form: {
      devEUI: 'DevEUI',
      type: 'Тип',
      status: 'Статус',
      model: 'Модель',
      node: 'Под управлением',
      serialNumber: 'Серийный номер',
    },
    rangeInput: {
      min: 'Мин.',
      max: 'Макс.',
      minValue: 'Мин. значение',
      maxValue: 'Макс. значение',
    },
    thresholds: {
      warning: 'Предупреждение при значениях',
      critical: 'Тревога при значениях',
      from: 'От',
      to: 'До',
      min: 'Мин.',
      max: 'Макс.',
    },
  },
  message: {
    confirmDelete: 'Вы хотите удалить?',
  },
  user: {
    table: {
      username: 'Имя пользователя',
      createdAt: 'Дата создания',
    },
    title: {
      createAccess: "Создать доступ",
      updateAccess: "Обновить доступ",
      accessesForUser: "Доступы для",
    },
    permissions: {
      edit: 'Редактировать доступ',
      delete: 'Удалить доступ',
      role: 'Роль',
      node: 'Узел',
      resourcesTitle: 'Ресурсы',
      explanationTitle: 'Объяснение ресурсов и статусов',
      accessAllowed: 'Доступ разрешен',
      accessDenied: 'Доступ запрещен',
      actions: {
        read: 'Просмотр информации',
        write: 'Создание или добавление новых данных',
        update: 'Изменение существующих данных',
        delete: 'Удаление данных',
        update_status: 'Обновление статуса ресурса',
      },
      resources: {
        USER: "Пользователи",
        CHAT: "Чат",
        EVENT: "Событие",
        FABRICATOR: "Производители",
        NODE: "Узел",
        MESSAGE: "Сообщение",
        OPTION: "Опции",
        PROFILE: "Профиль",
        SENSOR: "Датчики",
        TASK: "Задачи",
        VERIFICATION: "Верификации",
        RESPONSIBILITY: "Ответственные лица",
        TOKEN: "Токен",
        SETTINGS: "Настройки",
        ROLE: "Роли",
        MODEL: "Модели",
        INSPECTION_LOG: "Журнал обхода",
        LICENSE: "Лицензии",
      },
    },
    form: {
      username: 'Имя пользователя',
      role: 'Роль',
      node: 'Узел',
      apply: 'Сохранить',
      cancel: 'Отмена',
      password: 'Пароль',
      name: 'Имя',
      surname: 'Фамилия',
      patronymic: 'Отчество',
      dateOfBirth: 'Дата рождения',
      passwordCopied: 'Пароль был скопирован в буфер обмена!',
      generatePassword: 'Сгенерировать пароль',
      copyPassword: 'Скопировать пароль',
      phoneNumber: 'Номер телефона',
    },
  },
  notice: {
    table: {
      devEUI: 'devEUI',
      sensorType: 'Тип датчика',
      message: 'Сообщение',
      value: 'Значение',
      type: 'Тип',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
    },
    type: {
      WARN: 'Предупреждающий сигнал',
      CRITICAL: 'Критическая ошибка',
    },
  },
  inspectionLog: {
    title: 'Обходной журнал с }',
    executor: 'Исполнитель',
    action: 'Действие',
    dateTime: 'Дата и Время',
    userInfo: 'Информация о пользователе',
    name: 'Имя',
    status: {
      active: 'Активен',
      inactive: 'Неактивен',
    },
    download: 'Скачать',
    noData: 'Нет данных',
    nodes: {
      year: 'Год',
      month: 'Месяц',
      organization: 'Организация',
      factory: 'Завод',
      collectionPoint: 'Сборочный пункт',
      well: 'Скважина',
      field: 'Месторождение',
    },
  },
  optionPage: {
    title: 'Опции',
    tabs: {
      statusBoard: 'Доска статусов',
      unknownTab: 'Неизвестная вкладка',
    },
    droppableStatusCard: {
      statuses: {
        working: 'Рабочий процесс',
        warning: 'Предупреждение',
        error: 'Критический сбой',
      },
      placeholder: 'Перетащите сюда статус',
      saveButton: 'Сохранить',
      successMessage: 'Статусы успешно обновлены!',
    },
  },
  menu: {
    production: 'Производство',
    map: 'Карта',
    model: 'Модель',
    logs: 'События',
    excelParse: 'Разбор Excel',
    nodes: 'Иерархия',
    sensors: 'Датчики',
    users: 'Пользователи',
    reports: 'Отчеты',
    notices: 'Уведомления',
    inspectionLog: 'Журнал обхода',
    options: 'Опции',
    responsibility: 'Ответственные лица',
    roles: 'Роли',
    verification: 'Журнал поверки',
    settings: 'Настройки',
    licenses: 'Лицензии',
    profile: 'Профиль',
    state: 'Состояние',
    tuner: 'Конфигурация',
  },
  responsibilitiesPage: {
    table: {
      profileName: 'Имя Фамилия',
      node: 'Узел',
      sensor: 'Сенсор devEUI',
      updatedAt: 'Дата обновления',
      createdAt: 'Дата создания',
    },
    form: {
      selectNode: 'Выбрать узел',
      selectProfile: 'Выбрать профиль',
      selectSensor: 'Выбрать датчик',
    },
  },
  rolesPage: {
    table: {
      name: 'Название роли',
      createdAt: 'Дата создания',
    },
    form: {
      namePlaceholder: 'Введите название роли',
    },
  },
  verificationPage: {
    table: {
      devEUI: "devEUI",
      serialNumber: "Серийный номер",
      description: "Описание",
      verifiedAt: "Дата поверки",
      status: "Дата окончания поверки",
      createdAt: "Дата создания",
    },
    form: {
      serialNumberPlaceholder: "Серийный номер",
      verifiedAtPlaceholder: "Дата поверки",
      descriptionPlaceholder: "Описание",
    },
    status: {
      expired: "Срок поверки истек",
      expiringSoon: "Срок поверки истекает скоро",
      validUntil: "Действительно до {{date}}",
    },
  },
  settingsPage: {
    chips: {
      save: "Сохранить",
      tableFilling: "Заполнение таблиц",
      selectTables: "Список таблиц",
      excelFieldOrder: "Порядок полей в Excel",
      tableOrder: "Порядок таблиц",
      addItemPlaceholder: "Добавить элемент",
    },
    tabs: {
      tables: "Таблицы",
      parseExcel: "Разбор Excel",
      instantFlow: "Мгновенный расход",
    },
    messages: {
      requestSuccess: "Успешный запрос!",
    },
    tables: {
      node_closure: "Связи узлов",
      snapshot: "Снимок",
      migrations: "Миграции",
      node: "Узел",
      user_integration: "Интеграция пользователя",
      sensor: "Датчик",
      fabricator: "Производитель",
      model: "Модель",
      user: "Пользователь",
      profile: "Профиль",
      sensor_state: "Состояние датчика",
      node_user: "Связь узла с пользователем",
      role: "Роль",
      token: "Токен",
      job: "Задача",
      option: "Опция",
      settings: "Настройки",
      responsibility: "Ответственные лица",
      notice: "Уведомление",
      sensor_packet: "Пакет датчика",
      seeder: "Инициализация базы",
      event: "Событие",
      inspection_log: "Журнал обхода",
      verification: "Журнал поверки",
      translation: "Перевод",
    },
  },
  licensesPage: {
    licenses: {
      downloadLicenseInfo: "Скачать информацию о лицензии",
      dragOrClick: "Перетащите файл сюда или нажмите для выбора",
      uploadSuccess: "Лицензия успешно загружена!",
      uploadFail: "Не удалось загрузить лицензию",
      error: "Ошибка: ",
    },
    crud: {
      cancel: "Отмена",
      add: "Загрузить",
    },
  },
  crudTableView: {
    create: "Создать",
    update: "Обновить",
    cancel: "Отмена",
  },
  entity: {
    production: {
      singular: "Производство",
      plural: "Производства",
    },
    map: {
      singular: "Карта",
      plural: "Карты",
    },
    model: {
      singular: "Модель",
      plural: "Модели",
    },
    logs: {
      singular: "Лог",
      plural: "Логи",
    },
    excelParse: {
      singular: "Парсинг Excel",
      plural: "Парсинги Excel",
    },
    hierarchy: {
      singular: "Иерархия",
      plural: "Иерархии",
    },
    sensors: {
      singular: "Датчик",
      plural: "Датчики",
    },
    users: {
      singular: "пользователя",
      plural: "Пользователи",
    },
    reports: {
      singular: "Отчет",
      plural: "Отчеты",
    },
    notices: {
      singular: "Уведомление",
      plural: "Уведомления",
    },
    inspectionLog: {
      singular: "Журнал обхода",
      plural: "Журналы обхода",
    },
    options: {
      singular: "Опция",
      plural: "Опции",
    },
    responsibility: {
      singular: "Ответственное лицо",
      plural: "Ответственные лица",
    },
    roles: {
      singular: "Роль",
      plural: "Роли",
    },
    verification: {
      singular: "Поверка",
      plural: "Поверки",
    },
    settings: {
      singular: "Настройка",
      plural: "Настройки",
    },
    licenses: {
      singular: "Лицензия",
      plural: "Лицензии",
    },
    profile: {
      singular: "Профиль",
      plural: "Профили",
    },
  },
  noPermissions: {
    title: 'Доступ ограничен',
    message: 'У вас нет необходимых прав для просмотра этого раздела или выполнения данной операции.',
    suggestion: 'Если вы считаете, что это ошибка, пожалуйста, обратитесь к администратору системы или своему руководителю, чтобы уточнить настройки доступа.',
  },
  profilePage: {
    title: 'Профиль',
    telegramId: 'Телеграм ID',
    createdAt: 'Дата создания',
    updatedAt: 'Дата обновления',
    attachTelegram: 'Привязать Телеграм',
    confirmAttach: 'Подтвердите привязку аккаунта к Telegram',
    cancel: 'Отменить',
    apply: 'Согласиться',
    unlink: 'Открепить',
  },
  report: {
    title: "Отчёты",
    wellReportTitle: "Отчет по всем скважинам",
    wellReportTitleAlt: "Отчет о всех скважинах",
    download: "СКАЧАТЬ ОТЧЕТ",
    table: {
      name: "Имя",
      operationFactor: "Коэффициент эксплуатации",
      pipelinePressure: "Давление в шлейфе",
      wellPressure: "Давление в скважине",
      type: "Тип",
      volume: "Объем",
    },
  },
  personInfoModal: {
    title: "Информация ответственного лица",
    nameLabel: "ФИО",
    dobLabel: "Дата рождения",
    phoneLabel: "Номер телефона",
  },
  sensorsSendCommand: {
    successRequest: "Успешный запрос!",
    parameters: "Параметры",
    enterValuesCommaSeparated: "Введите значения через запятую",
    enterValue: "Введите значение",
    modelDoesNotSupportForm: "Модель не поддерживает форму",
    send: 'Отправить',
  },

}, 'ru')

appendLocaleSources({
  dimension: {
    VOLUME: {
      humanize: ['m³', 'k m³', 'M m³', 'B m³', 'T m³'],
    },
    TEMPERATURE: {
      humanize: ['°C', 'k °C', 'M °C', 'B °C', 'T °C'],
    },

    PRESSURE: {
      humanize: ['kgf/cm²', 'k kgf/cm²', 'M kgf/cm²', 'B kgf/cm²', 'T kgf/cm²'],
    },
  },
  productionPage: {
    table: {
      type: 'Field',
      name: 'Name',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
    },
  },
  productionLabels: {
    hourlyProduction: 'Hourly Production',
    dailyProduction: 'Daily Production',
    monthlyProduction: 'Monthly Production',
    yearlyProduction: 'Yearly Production',
    operatingFactor: 'Operating Factor',
    wellFund: 'Well Fund',
    totalFund: 'Total Fund',
    active: 'Active',
    blowing: 'Blowing',
    control: 'Control',
    static: 'Static',
    downtime: 'Downtime',
    maintenance: 'Maintenance',
    drilling: 'Drilling',
    liquidation: 'Liquidation',
  },
  time: {
    per: {
      year: 'year',
      month: 'month',
      day: 'day',
      hour: 'hour',
      minute: 'minute',
      second: 'second',
    },
  },
  type: {
    node: {
      ORGANIZATION: 'Organization',
      FACTORY: 'Factory',
      COLLECTION_POINT: 'Collection Point',
      WELL: 'Well',
      HOLE: 'To the well',
      FIELD: 'Field',
      PLATFORM: 'Platform',
    },
    sensor: {
      TEMPERATURE: 'Temperature',
      TILT: 'Tilt',
      VOLUME: 'Volume',
      PRESSURE: 'Pressure',
      PRESSURE_INPUT: 'Input Pressure',
      PRESSURE_OUTPUT: 'Output Pressure',
      PRESSURE_WELL: 'Well Pressure',
      PRESSURE_PLUME: 'Plume Pressure',
      FLOW_RATE: 'Flow Rate',
    },
    pressure: {
      input: 'input',
      output: 'output',
      at: 'at',
      plume: 'plume',
      and: 'and',
      in: 'in',
    },
  },
  status: {
    sensor: {
      WORKING: 'Working',
      NO_SIGNAL: 'No signal',
      SHORT_CIRCUIT: 'Short circuit',
      TECH_WORKS: 'Maintenance',
      NO_SENSOR_SIGNAL: 'Sensor is not connected',
      PLUME_PRESSURE_EXCESS: 'Excessive plume pressure',
      UNDER_LIMIT: 'Lower limit exceeded',
      OVER_LIMIT: 'Upper limit exceeded',
      ABNORMAL_VALUE: 'Abnormal reading',
      CRITICAL_VALUE: 'Critical reading',
      CALIBRATION_REQUIRED: 'Calibration required',
      UNKNOWN_UNIT: 'Unknown unit',
      INVALID_DRIVER: 'Invalid driver',
    },
    node: {
      WORKING: 'Working',
      BLOWING: 'Blowing',
      DOWNTIME: 'Downtime',
      TECH_WORKS: 'Maintenance',
      STATIC: 'Static state',
      CONTROL: 'Control',
      LIQUIDATION: 'Liquidation',
      DRILLING: 'Drilling',
      MAINTENANCE: 'Repair',
    },
  },
  crud: {
    add: 'Add',
    addItem: 'Add ${item}',
    edit: 'Edit',
    delete: 'Delete',
  },
  modal: {
    editWellStatusModal: {
      title: 'Edit well status',
      close: 'Close',
      apply: 'Apply',
      wellStatusPlaceholder: 'Well status',
    },
  },
  wellInfo: {
    status: 'Well status',
    technicalInfo: 'Technical information',
    pipelineDiameter: 'Pipeline diameter',
    pipelineLength: 'Pipeline length',
    pipelineThickness: 'Pipeline thickness',
    responsiblePersons: 'Responsible persons',
    instantaneousFlowRate: 'Instantaneous well flow rate',
    unit: 'unit',
  },
  summary: {
    ORGANIZATION: 'Summary data for organization "${name}"',
    FACTORY: 'Summary data for factory "${name}"',
    COLLECTION_POINT: 'Summary data for collection point "${name}"',
    WELL: 'Summary data for well "${name}"',
    FIELD: 'Summary data for field "${name}"',
    DEFAULT: 'Summary data for object "${name}"',
  },
  averagePressure: {
    daily: 'Average daily pressure:',
    monthly: 'Average monthly pressure:',
    yearly: 'Average yearly pressure:',
  },
  averageTemperature: {
    daily: "Average daily temperature:",
    monthly: 'Average monthly temperature:',
    yearly: 'Average yearly temperature:',
  },
  sensorInfo: {
    modalTitle: 'Sensor Information ${title}',
    lastData: 'Last Data',
    lastReading: 'Last Reading',
    lastEventAt: 'Last event',
    sensorState: 'Sensor State',
    interval: 'Interval',
    voltage: 'Voltage',
    uptime: 'Uptime',
    sensorStatus: 'Sensor Status',
    mainInfo: 'Main Information',
    devEUI: 'DevEUI',
    createdAt: 'Created At',
    serialNumber: 'Serial Number',
    fabricator: 'Fabricator',
    verificationDate: 'Verification Date',
    verificationExpire: 'Verification Expiry Date',
    noData: 'No Data',
    close: 'Close',
  },
  chart: {
    "pressurePlume": "Plume Pressure",
    "pressureWell": "Well Pressure",
    "temperature": "Temperature",
    "time": "Time",
    "pressureUnit": "Pressure (kgf/cm²)",
    "temperatureUnit": "Temperature (°C)",
  },
  dateChart: {
    "datePlaceholder": {
      'from': "Date from",
      'to': "Date to",
    },
    "apply": "Apply",
  },
  model: {
    createManufacturer: 'Create Manufacturer',
    manufacturerName: 'Name',
    create: 'Create',
    cancel: 'Cancel',
    apply: 'Apply',
    delete: 'Delete',
    close: 'Close',
    edit: 'Edit',
    modelTitle: 'Model',
    models: 'Models',
    unnamed: 'Unnamed',
    deleteConfirmation: 'Are you sure you want to delete this model?',
    unsavedChangesTitle: 'Unsaved Changes',
    unsavedChangesMessage: 'You have unsaved changes. Do you want to continue without saving?',
    reset: 'Reset',
    executeTests: 'Run Tests',
    save: 'Save',
    jsonResult: 'This will be your JSON result',
    testResults: 'This will be your test result',
    testSuccess: 'Tests passed successfully',
    testFail: 'Test failed',
    modelDetails: 'Model Details',
    validityDays: 'Validity (days)',
    driverFunction: 'Driver Function',
    sourceCode: 'Source Code',
    selectManufacturer: 'Select Manufacturer',
    selectModel: 'Select Model',
    modelList: 'Model List',
    addModel: 'Add Model',
    successSave: 'Save Successful',
    errorSave: 'Save Error',
    manufacturerCreated: 'Manufacturer Created',
    saveSuccessTitle: 'Save Successful',
    saveSuccessSubtitle: 'Model saved successfully.',
    saveErrorTitle: 'Save Error',
    saveErrorSubtitle: 'Failed to save model. Error:',
    deleteSuccess: "Model deleted successfully",
    deleteError: "Error deleting model",
  },
  uploadExcel: {
    pageTitle: 'Upload Excel',
    showErrorsOnly: 'Show only records with errors',
    fileUpload: 'Upload File',
    devEUI: 'DevEUI',
    appKey: 'Application Key',
    devAddr: 'Device Address',
    limits_max: 'Max Limit',
    limits_min: 'Min Limit',
    name: 'Name',
    status: 'Status',
    thresholds_critical_max: 'Max Critical Threshold',
    thresholds_critical_min: 'Min Critical Threshold',
    thresholds_warn_max: 'Max Warning Threshold',
    thresholds_warn_min: 'Min Warning Threshold',
    type: 'Type',
    error: 'Error',
  },
  nodes: {
    pageTitle: 'Node Management',
    confirmDelete: 'Are you sure you want to delete this node?',
    createNode: 'Create Node',
    updateNode: 'Update Node',
    nodeInside: 'Create a node inside:',
    updateNodeInside: 'Update node:',
    close: 'Close',
    type: 'Type',
    underControl: 'Under Control',
    serverIp: 'Managing server IP address',
    apply: 'Apply',
    create: 'Create',
    update: 'Update',
    name: 'Name',
    error: 'Error',
    plumeDiameter: 'Plume Diameter',
    chirpstackInstalled: 'ChirpStack is installed',
    plumeLength: 'Plume Length',
    pipeThickness: 'Pipe Thickness',
  },
  prompt: {
    title: 'Attention!',
    yes: 'Yes',
    no: 'No',
    message: {
      confirmDelete: `Are you sure you want to delete the manufacturer?`,
    },
  },
  sensor: {
    modal: {
      configureInterval: 'Configure exit interval',
      changeStatus: 'Change sensor status',
      packageInfo: 'Package information',
      sensorEvents: 'Sensor events',
      noData: 'No data available!',
    },
    table: {
      devEUI: 'DevEUI',
      node: 'Node',
      serialNumber: 'Serial number',
      model: 'Model',
      exitInterval: 'Exit interval',
      type: 'Type',
      status: 'Sensor status',
      createdAt: 'Created at',
      packages: 'Packages',
      edit: 'Edit',
      overview: 'Overview',
      history: 'History',
      minutes: 'Min',
      intervalPlaceholder: 'Response interval in minutes',
    },
    status: {
      PENDING: 'Pending',
      ERROR: 'Error',
      SENT: 'Success',
      ABANDONED: 'Abandoned',
    },
    diff: {
      limit: 'Limit',
      status: 'Status',
      thresholds: 'Thresholds',
      updatedAt: 'Updated at',
      prevMin: 'Prev Min:',
      prevMax: 'Prev Max:',
      min: 'Min:',
      max: 'Max:',
      prevWarn: 'Prev Warning:',
      prevCritical: 'Prev Critical:',
      warn: 'Warning:',
      critical: 'Critical:',
    },
    history: {
      value: 'Value',
      voltage: 'Voltage',
      type: 'Type',
      nodeStatus: 'Well status',
      sensorStatus: 'Sensor status',
      at: 'At',
      voltageUnit: '{value} V',
    },
    form: {
      devEUI: "DevEUI",
      type: "Type",
      status: "Status",
      model: "Model",
      node: "Under control",
      serialNumber: "Serial number",
    },
    rangeInput: {
      min: "Min.",
      max: "Max.",
      minValue: "Min. value",
      maxValue: "Max. value",
    },
    thresholds: {
      warning: "Warning at values",
      critical: "Critical at values",
      from: "From",
      to: "To",
      min: "Min.",
      max: "Max.",
    },
    alerts: {
      noHistoryData: 'No history data available',
      fetchError: 'Error fetching data',
    },
  },
  message: {
    confirmDelete: 'Do you want to delete?',
  },
  user: {
    title: {
      createAccess: "Create Access",
      updateAccess: "Update Access",
      accessesForUser: "Accesses for ",
    },
    table: {
      username: 'Username',
      createdAt: 'Creation Date',
    },
    permissions: {
      edit: 'Edit Access',
      delete: 'Delete Access',
      role: 'Role',
      node: 'Node',
      explanationTitle: "Explanation of Resources and Statuses",
      accessAllowed: "Access Allowed",
      accessDenied: "Access Denied",
      resourcesTitle: "Resources",
      actions: {
        read: "View Information",
        write: "Create or Add New Data",
        update: "Modify Existing Data",
        delete: "Delete Data",
        update_status: "Update Resource Status",
      },
      resources: {
        USER: 'Users',
        CHAT: 'Chat',
        EVENT: 'Event',
        FABRICATOR: 'Manufacturers',
        NODE: 'Node',
        MESSAGE: 'Message',
        OPTION: 'Options',
        PROFILE: 'Profile',
        SENSOR: 'Sensors',
        TASK: 'Tasks',
        VERIFICATION: 'Verification log',
        RESPONSIBILITY: 'Responsible Persons',
        TOKEN: 'Token',
        SETTINGS: 'Settings',
        ROLE: 'Roles',
        MODEL: 'Models',
        INSPECTION_LOG: 'Inspection Log',
        LICENSE: 'Licenses',
      },

    },
    form: {
      username: 'Username',
      role: 'Role',
      node: 'Node',
      apply: 'Save',
      cancel: 'Cancel',
      password: 'Password',
      name: 'First Name',
      surname: 'Last Name',
      patronymic: 'Middle Name',
      phoneNumber: 'Phone number',
      dateOfBirth: 'Date of Birth',
      passwordCopied: 'Password has been copied to the clipboard!',
      generatePassword: 'Generate Password',
      copyPassword: 'Copy Password',
    },
  },
  notice: {
    table: {
      devEUI: 'devEUI',
      sensorType: 'Sensor Type',
      message: 'Message',
      value: 'Value',
      type: 'Type',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
    },
    type: {
      WARN: 'Warning Signal',
      CRITICAL: 'Critical Error',
    },
  },
  inspectionLog: {
    title: 'Inspection Log from ${date}',
    executor: 'Executor',
    action: 'Action',
    dateTime: 'Date and Time',
    userInfo: 'User Information',
    name: 'Name',
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    download: 'Download',
    noData: 'No Data',
    nodes: {
      year: 'Year',
      month: 'Month',
      organization: 'Organization',
      factory: 'Factory',
      collectionPoint: 'Collection Point',
      well: 'Well',
      field: 'Field',
    },
  },
  optionPage: {
    title: 'Options',
    tabs: {
      statusBoard: 'Status Board',
      unknownTab: 'Unknown Tab',
    },
    droppableStatusCard: {
      statuses: {
        working: 'Working Process',
        warning: 'Warning',
        error: 'Critical Failure',
      },
      placeholder: 'Drag status here',
      saveButton: 'Save',
      successMessage: 'Statuses updated successfully!',
    },
  },
  responsibilitiesPage: {
    table: {
      profileName: 'First Name Last Name',
      node: 'Node',
      sensor: 'Sensor devEUI',
      updatedAt: 'Updated At',
      createdAt: 'Created At',
    },
    form: {
      selectNode: 'Select Node',
      selectProfile: 'Select Profile',
      selectSensor: 'Select Sensor',
    },
  },
  menu: {
    production: 'Production',
    map: 'Map',
    model: 'Model',
    logs: 'Logs',
    excelParse: 'Excel Parse',
    nodes: 'Nodes',
    sensors: 'Sensors',
    users: 'Users',
    reports: 'Reports',
    notices: 'Notices',
    inspectionLog: 'Inspection Log',
    options: 'Options',
    responsibility: 'Responsible Persons',
    roles: 'Roles',
    verification: 'Verification log',
    settings: 'Settings',
    licenses: 'Licenses',
    profile: 'Profile',
    state: 'State',
  },
  rolesPage: {
    table: {
      name: 'Role Name',
      createdAt: 'Created At',
    },
    form: {
      namePlaceholder: 'Enter role name',
    },
  },
  verificationPage: {
    table: {
      devEUI: "devEUI",
      serialNumber: "Serial Number",
      description: "Description",
      verifiedAt: "Verification Date",
      status: "Verification Expiry Date",
      createdAt: "Created At",
    },
    form: {
      serialNumberPlaceholder: "Serial Number",
      verifiedAtPlaceholder: "Verification Date",
      descriptionPlaceholder: "Description",
    },
    status: {
      expired: "Verification expired",
      expiringSoon: "Verification expiring soon",
      validUntil: "Valid until {{date}}",
    },
  },
  settingsPage: {
    chips: {
      save: "Save",
      tableFilling: "Table Filling",
      selectTables: "List of Tables",
      excelFieldOrder: "Excel Field Order",
      tableOrder: "Table Order",
      addItemPlaceholder: "Add Item",
    },
    tabs: {
      tables: "Tables",
      parseExcel: "Parse Excel",
      instantFlow: "Instant Flow",
    },
    messages: {
      requestSuccess: "Request successful!",
    },
    tables: {
      node_closure: "Node Closure",
      snapshot: "Snapshot",
      migrations: "Migrations",
      node: "Node",
      user_integration: "User Integration",
      sensor: "Sensor",
      fabricator: "Fabricator",
      model: "Model",
      user: "User",
      profile: "Profile",
      sensor_state: "Sensor State",
      node_user: "Node-User Link",
      role: "Role",
      token: "Token",
      job: "Job",
      option: "Option",
      settings: "Settings",
      responsibility: "Responsibilities",
      notice: "Notice",
      sensor_packet: "Sensor Packet",
      seeder: "Database Seeder",
      event: "Event",
      inspection_log: "Inspection Log",
      verification: "Verification",
      translation: "Translation",
    },
  },
  licensesPage: {
    licenses: {
      downloadLicenseInfo: "Download license information",
      dragOrClick: "Drag a file here or click to select",
      uploadSuccess: "License uploaded successfully!",
      uploadFail: "Failed to upload the license",
      error: "Error: {{message}}",
    },
    crud: {
      cancel: "Cancel",
      add: "Upload",
    },
  },
  crudTableView: {
    create: "Create",
    update: "Update",
    cancel: "Cancel",
  },
  entity: {
    production: {
      singular: "Production",
      plural: "Productions",
    },
    map: {
      singular: "Map",
      plural: "Maps",
    },
    model: {
      singular: "Model",
      plural: "Models",
    },
    logs: {
      singular: "Log",
      plural: "Logs",
    },
    excelParse: {
      singular: "Excel Parse",
      plural: "Excel Parses",
    },
    hierarchy: {
      singular: "Hierarchy",
      plural: "Hierarchies",
    },
    sensors: {
      singular: "Sensor",
      plural: "Sensors",
    },
    users: {
      singular: "User",
      plural: "Users",
    },
    reports: {
      singular: "Report",
      plural: "Reports",
    },
    notices: {
      singular: "Notice",
      plural: "Notices",
    },
    inspectionLog: {
      singular: "Inspection Log",
      plural: "Inspection Logs",
    },
    options: {
      singular: "Option",
      plural: "Options",
    },
    responsibility: {
      singular: "Responsible Person",
      plural: "Responsible Persons",
    },
    roles: {
      singular: "Role",
      plural: "Roles",
    },
    verification: {
      singular: "Verification",
      plural: "Verifications",
    },
    settings: {
      singular: "Setting",
      plural: "Settings",
    },
    licenses: {
      singular: "License",
      plural: "Licenses",
    },
    profile: {
      singular: "Profile",
      plural: "Profiles",
    },
  },
  noPermissions: {
    title: 'Access Restricted',
    message: 'You do not have the necessary permissions to view this section or perform this action.',
    suggestion: 'If you believe this is a mistake, please contact your system administrator or supervisor to check access settings.',
  },
  profilePage: {
    title: 'Profile',
    telegramId: 'Telegram ID',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    attachTelegram: 'Attach Telegram',
    confirmAttach: 'Confirm account linking to Telegram',
    cancel: 'Cancel',
    apply: 'Apply',
    unlink: 'Unlink',
  },
  report: {
    title: "Reports",
    wellReportTitle: "Report for all wells",
    wellReportTitleAlt: "Report on all wells",
    download: "DOWNLOAD REPORT",
    table: {
      name: "Name",
      operationFactor: "Operation Factor",
      pipelinePressure: "Pipeline Pressure",
      wellPressure: "Well Pressure",
      type: "Type",
      volume: "Volume",
    },
  },
  personInfoModal: {
    title: "Responsible Person Informationа",
    nameLabel: "Full Name",
    dobLabel: "Date of Birth",
    phoneLabel: "Phone Number",
  },
  sensorsSendCommand: {
    successRequest: "Successful request!",
    parameters: "Parameters",
    enterValuesCommaSeparated: "Enter values separated by commas",
    enterValue: "Enter value",
    modelDoesNotSupportForm: "The model does not support the form",
    send: "Send",
  },

}, 'en')

appendLocaleSources({
  dimension: {
    VOLUME: {
      humanize: ['m³', 'ming m³', 'mln m³', 'mlrd m³', 'trl m³'],
    },
    TEMPERATURE: {
      humanize: ['°C', 'ming °C', 'mln °C', 'mlrd °C', 'trl °C'],
    },
    PRESSURE: {
      humanize: ['kgf/sm²', 'ming kgf/sm²', 'mln kgf/sm²', 'mlrd kgf/sm²', 'trl kgf/sm²'],
    },
  },
  time: {
    per: {
      year: 'yil',
      month: 'oy',
      day: 'kun',
      hour: 'soat',
      minute: 'daqiqa',
      second: 'soniya',
    },
  },
  productionPage: {
    table: {
      type: 'Kon',
      name: 'Nomi',
      createdAt: 'Yaratilgan sana',
      updatedAt: 'Yangilangan sana',
    },
  },
  productionLabels: {
    hourlyProduction: 'Soatlik qazib olish',
    dailyProduction: 'Kunlik qazib olish',
    monthlyProduction: 'Oylik qazib olish',
    yearlyProduction: 'Yillik qazib olish',
    operatingFactor: 'Ekspluatatsiya koeffitsiyenti',
    wellFund: 'Quduqlar jamg‘armasi',
    totalFund: 'Umumiy fond',
    active: 'Faol',
    blowing: 'Puflash',
    control: 'Nazorat',
    static: 'Statik',
    downtime: 'To‘xtab turish',
    maintenance: 'Ta’mirlash',
    drilling: 'Burg‘ulash',
    liquidation: 'Tasfiya qilish',
  },
  type: {
    node: {
      ORGANIZATION: 'Tashkilot',
      FACTORY: 'Zavod',
      COLLECTION_POINT: 'Yig‘ish punkti',
      WELL: 'Quduq',
      HOLE: 'Skvazhine',
      FIELD: 'Kon',
      PLATFORM: 'Platforma',
    },
    sensor: {
      TEMPERATURE: 'Harorat',
      TILT: 'Egish',
      VOLUME: 'Hajm',
      PRESSURE: 'Bosim',
      PRESSURE_INPUT: 'Kirish bosimi',
      PRESSURE_OUTPUT: 'Chiqish bosimi',
      PRESSURE_WELL: 'Quduq bosimi',
      PRESSURE_PLUME: 'Shleyf bosimi',
      FLOW_RATE: 'Oqim tezligi',
    },
    pressure: {
      input: 'kirish',
      output: 'chiqish',
      at: 'da',
      plume: 'shleyfda',
      and: 'va',
      in: 'va',
    },
  },
  status: {
    sensor: {
      WORKING: 'Ishlayapti',
      NO_SIGNAL: 'Signal yo‘q',
      SHORT_CIRCUIT: 'Qisqa tutashuv',
      TECH_WORKS: 'Texnik xizmat',
      NO_SENSOR_SIGNAL: 'Datchik ulanmagan',
      PLUME_PRESSURE_EXCESS: 'Shleyf bosimi ortiqcha',
      UNDER_LIMIT: 'Quyi chegara buzildi',
      OVER_LIMIT: 'Yuqori chegara oshib ketdi',
      ABNORMAL_VALUE: 'G‘ayritabiiy ko‘rsatkich',
      CRITICAL_VALUE: 'Tanqidiy ko‘rsatkich',
      CALIBRATION_REQUIRED: 'Kalibrovka talab qilinadi',
      UNKNOWN_UNIT: "Nomaʼlum oʻlchov birligi",
      INVALID_DRIVER: "Notoʻgʻri drayver",
    },
    node: {
      WORKING: 'Ishlamoqda',
      BLOWING: 'Puflash',
      DOWNTIME: 'To‘xtab turish',
      TECH_WORKS: 'Texnik xizmat',
      STATIC: 'Statik holat',
      CONTROL: 'Nazorat',
      LIQUIDATION: 'Tasfiya qilish',
      DRILLING: 'Burg‘ulash',
      MAINTENANCE: 'Ta’mirlash',
    },
  },
  crud: {
    add: 'Qo‘shish',
    addItem: '${item} qo‘shish',
    edit: 'Tahrirlash',
    delete: 'O‘chirish',
  },
  modal: {
    editWellStatusModal: {
      title: 'Quduq holatini tahrirlash',
      close: 'Yopish',
      apply: 'Qo‘llash',
      wellStatusPlaceholder: 'Quduq holati',
    },
  },
  wellInfo: {
    status: 'Quduq holati',
    technicalInfo: 'Texnik ma’lumot',
    pipelineDiameter: 'Quvur diametri',
    pipelineLength: 'Quvur uzunligi',
    pipelineThickness: 'Quvur qalinligi',
    responsiblePersons: 'Mas’ul shaxslar',
    instantaneousFlowRate: 'Quduqning joriy oqimi',
    unit: 'birlik',
  },
  summary: {
    ORGANIZATION: 'Tashkilot bo‘yicha umumiy ma’lumot "${name}"',
    FACTORY: 'Zavod bo‘yicha umumiy ma’lumot "${name}"',
    COLLECTION_POINT: 'Yig‘ish punkti bo‘yicha umumiy ma’lumot "${name}"',
    WELL: 'Quduq bo‘yicha umumiy ma’lumot "${name}"',
    FIELD: 'Kon bo‘yicha umumiy ma’lumot "${name}"',
    DEFAULT: 'Obyekt bo‘yicha umumiy ma’lumot "${name}"',
  },
  averagePressure: {
    daily: 'O‘rtacha sutkalik bosim:',
    monthly: 'O‘rtacha oylik bosim:',
    yearly: 'O‘rtacha yillik bosim:',
  },
  averageTemperature: {
    daily: "O'rtacha kunlik harorat:",
    monthly: "O'rtacha oylik harorat:",
    yearly: "O'rtacha yillik harorat:",
  },
  sensorInfo: {
    modalTitle: 'Datchik haqida ma’lumot ${title}',
    lastData: 'Oxirgi ma’lumotlar',
    lastReading: 'Oxirgi ko‘rsatkichlar',
    lastEventAt: 'Oxirgi hodisa',
    sensorState: 'Datchik holati',
    interval: 'Interval',
    voltage: 'Kuchlanish',
    uptime: 'Ish vaqti',
    sensorStatus: 'Datchik statusi',
    mainInfo: 'Asosiy ma’lumot',
    devEUI: 'DevEUI',
    createdAt: 'Yaratilgan sana',
    serialNumber: 'Seriya raqami',
    fabricator: 'Ishlab chiqaruvchi',
    verificationDate: 'Foydalanishga topshirish sanasi',
    verificationExpire: 'Tekshiruv muddati tugash sanasi',
    noData: 'Ma’lumot yo‘q',
    close: 'Yopish',
  },
  chart: {
    "pressurePlume": "Shleyf bosimi",
    "pressureWell": "Quduq bosimi",
    "temperature": "Harorat",
    "time": "Vaqt",
    "pressureUnit": "Bosim (kgf/sm²)",
    "temperatureUnit": "Harorat (°C)",
  },
  dateChart: {
    "datePlaceholder": {
      'from': "Sanani tanlang (dan)",
      'to': "Sanani tanlang (gacha)",
    },
    "apply": "Qo‘llash",
  },
  model: {
    createManufacturer: "Ishlab chiqaruvchini yaratish",
    manufacturerName: "Nomi",
    create: "Yaratish",
    cancel: "Bekor qilish",
    apply: "Qo‘llash",
    delete: "O‘chirish",
    close: "Yopish",
    edit: "Tahrirlash",
    modelTitle: "Model",
    models: "Modellar",
    unnamed: "Nomsiz",
    deleteConfirmation: "Ushbu modelni o‘chirib tashlashni istaysizmi?",
    unsavedChangesTitle: "Saqlanmagan o‘zgarishlar",
    unsavedChangesMessage: "Sizda saqlanmagan o‘zgarishlar mavjud. Saqlamasdan davom etishni istaysizmi?",
    reset: "Qayta tiklash",
    executeTests: "Testlarni ishga tushirish",
    save: "Saqlash",
    jsonResult: "Bu sizning JSON natijangiz bo‘ladi",
    testResults: "Bu sizning test natijangiz bo‘ladi",
    testSuccess: "Testlar muvaffaqiyatli o‘tdi",
    testFail: "Test muvaffaqiyatsiz yakunlandi",
    modelDetails: "Model tafsilotlari",
    validityDays: "Amal qilish muddati (kun)",
    driverFunction: "Draiver funksiyasi",
    sourceCode: "Manba kodi",
    selectManufacturer: "Ishlab chiqaruvchini tanlash",
    selectModel: "Modelni tanlash",
    modelList: "Modellar ro‘yxati",
    addModel: "Model qo‘shish",
    successSave: "Saqlash muvaffaqiyatli",
    errorSave: "Saqlashda xatolik",
    manufacturerCreated: "Ishlab chiqaruvchi yaratildi",
    saveSuccessTitle: "Saqlash muvaffaqiyatli",
    saveSuccessSubtitle: "Model muvaffaqiyatli saqlandi.",
    saveErrorTitle: "Saqlashda xatolik",
    saveErrorSubtitle: "Modelni saqlab bo'lmadi. Xato:",
    deleteSuccess: "Model muvaffaqiyatli o'chirildi",
    deleteError: "Modelni o'chirishda xatolik yuz berdi",
  },
  uploadExcel: {
    pageTitle: "Excel yuklash",
    showErrorsOnly: "Faqat xatolar bilan yozuvlarni ko'rsatish",
    fileUpload: "Fayl yuklash",
    devEUI: "DevEUI",
    appKey: "Dastur kaliti",
    devAddr: "Qurilma manzili",
    limits_max: "Maks. chegara",
    limits_min: "Min. chegara",
    name: "Nomi",
    status: "Holat",
    thresholds_critical_max: "Maks. tanqidiy chegara",
    thresholds_critical_min: "Min. tanqidiy chegara",
    thresholds_warn_max: "Maks. ogohlantirish chegara",
    thresholds_warn_min: "Min. ogohlantirish chegara",
    type: "Turi",
    error: "Xato",
  },
  nodes: {
    pageTitle: "Uzlarga boshqaruv",
    confirmDelete: "Bu uzelni o'chirmoqchi ekanligingizga ishonchingiz komilmi?",
    createNode: "Uzel yaratish",
    updateNode: "Uzelni yangilash",
    nodeInside: "Ichida uzel yaratish: ",
    updateNodeInside: "Uzelni yangilash: ",
    close: "Yopish",
    type: "Turi",
    underControl: "Boshqaruv ostida",
    serverIp: "Boshqaruvchi serverning IP-manzili",
    apply: "Qo'llash",
    create: "Yaratish",
    update: "Yangilash",
    name: "Nomi",
    error: "Xato",
    pipeThickness: 'Quvur qalinligi',
    chirpstackInstalled: 'ChirpStack o‘rnatilgan',
    plumeLength: 'Plume uzunligi',
    plumeDiameter: 'Plume diametri',
  },
  prompt: {
    title: 'Diqqat!',
    yes: 'Ha',
    no: 'Yoʻq',
    message: {
      confirmDelete: `Ishlab chiqaruvchini o‘chirishni xohlaysizmi?`,
    },
  },
  sensor: {
    modal: {
      configureInterval: 'Chiqish intervalini sozlash',
      changeStatus: 'Datchik holatini o‘zgartirish',
      packageInfo: 'Paket maʼlumotlari',
      sensorEvents: 'Datchik hodisalari',
      noData: 'Maʼlumot yo‘q!',
    },
    table: {
      devEUI: 'DevEUI',
      node: 'Uzel',
      serialNumber: 'Seriya raqami',
      model: 'Model',
      exitInterval: 'Chiqish intervali',
      type: 'Turi',
      status: 'Datchik holati',
      createdAt: 'Yaratilgan sana',
      packages: 'Paketlar',
      edit: 'Tahrirlash',
      overview: 'Ko‘rib chiqish',
      history: 'Tarix',
      minutes: 'Daqiqa',
      intervalPlaceholder: 'Javob intervali (daqiqa)',
    },
    status: {
      PENDING: 'Kutilmoqda',
      ERROR: 'Xato',
      SENT: 'Muvaffaqiyatli',
      ABANDONED: 'Tashlab qo‘yilgan',
    },
    diff: {
      limit: 'Chegara',
      status: 'Holat',
      thresholds: 'Chegaralar',
      updatedAt: 'Yangilangan sana',
      prevMin: 'Oldingi min:',
      prevMax: 'Oldingi max:',
      min: 'Min:',
      max: 'Max:',
      prevWarn: 'Oldingi ogohlantirish:',
      prevCritical: 'Oldingi tanqidiy:',
      warn: 'Ogohlantirish:',
      critical: 'Tanqidiy:',
    },
    history: {
      value: 'Qiymat',
      voltage: 'Kuchlanish',
      type: 'Turi',
      nodeStatus: 'Quduq holati',
      sensorStatus: 'Datchik holati',
      at: 'Vaqt',
      voltageUnit: '{value} V',
    },
    form: {
      devEUI: "DevEUI",
      type: "Turi",
      status: "Holat",
      model: "Model",
      node: "Boshqaruv ostida",
      serialNumber: "Seriya raqami",
    },
    rangeInput: {
      min: "Min.",
      max: "Maks.",
      minValue: "Minimal qiymat",
      maxValue: "Maksimal qiymat",
    },
    thresholds: {
      warning: "Qiymatlardagi ogohlantirish",
      critical: "Qiymatlardagi og‘ir holat",
      from: "Dan",
      to: "Gacha",
      min: "Min.",
      max: "Maks.",
    },
    alerts: {
      noHistoryData: 'Tarixiy maʼlumot yo‘q',
      fetchError: 'Maʼlumot olishda xato',
    },
  },
  message: {
    confirmDelete: 'Foydalanuvchini o‘chirishni?',
  },
  user: {
    table: {
      username: 'Foydalanuvchi nomi',
      createdAt: 'Yaratilgan sana',
    },
    title: {
      createAccess: "Kirish yaratish",
      updateAccess: "Kirishni yangilash",
      accessesForUser: "${selectUser?.username} uchun kirishlar",
    },
    permissions: {
      edit: 'Kirishni tahrirlash',
      delete: 'Kirishni o‘chirish',
      role: 'Rol',
      node: 'Tugun',
      explanationTitle: "Resurslar va holatlarning tushuntirishi",
      accessAllowed: "Ruxsat berilgan",
      accessDenied: "Ruxsat berilmagan",
      resourcesTitle: "Resurslar",
      actions: {
        read: "Ma'lumotlarni ko'rish",
        write: "Yangi ma'lumot qo'shish",
        update: "Mavjud ma'lumotlarni o'zgartirish",
        delete: "Ma'lumotlarni o'chirish",
        update_status: "Resurs holatini yangilash",
      },
      resources: {
        USER: 'Foydalanuvchilar',
        CHAT: 'Chat',
        EVENT: 'Voqea',
        FABRICATOR: 'Ishlab chiqaruvchilar',
        NODE: 'Tugun',
        MESSAGE: 'Xabar',
        OPTION: 'Variantlar',
        PROFILE: 'Profil',
        SENSOR: 'Sensorlar',
        TASK: 'Vazifalar',
        VERIFICATION: 'Tekshirish jurnali',
        RESPONSIBILITY: 'Mas’ul shaxslar',
        TOKEN: 'Token',
        SETTINGS: 'Sozlamalar',
        ROLE: 'Rollar',
        MODEL: 'Modellar',
        INSPECTION_LOG: 'Tekshiruv jurnali',
        LICENSE: 'Litsenziyalar',
      },

    },
    form: {
      username: 'Foydalanuvchi nomi',
      role: 'Rol',
      node: 'Tugun',
      apply: 'Saqlash',
      cancel: 'Bekor qilish',
      password: 'Parol',
      name: 'Ism',
      surname: 'Familiya',
      patronymic: 'Otasining ismi',
      phoneNumber: 'Telefon raqami',
      dateOfBirth: 'Tug‘ilgan sana',
      passwordCopied: 'Parol buferga nusxalandi!',
      generatePassword: 'Parol yaratish',
      copyPassword: 'Parolni nusxalash',
    },
  },
  notice: {
    table: {
      devEUI: 'devEUI',
      sensorType: 'Datchik turi',
      message: 'Xabar',
      value: 'Qiymat',
      type: 'Turi',
      createdAt: 'Yaratilgan sana',
      updatedAt: 'Data obnovleniya',
    },
    type: {
      WARN: 'Ogohlantiruvchi signal',
      CRITICAL: 'Tanqidiy xato',
    },
  },
  inspectionLog: {
    title: 'Tekshiruv jurnali: ${date}',
    executor: 'Ijrochi',
    action: 'Harakat',
    dateTime: 'Sana va vaqt',
    userInfo: 'Foydalanuvchi ma’lumoti',
    name: 'Ism',
    status: {
      active: 'Faol',
      inactive: 'Faol emas',
    },
    download: 'Yuklab olish',
    noData: 'Maʼlumot yo‘q',
    nodes: {
      year: 'Yil',
      month: 'Oy',
      organization: 'Tashkilot',
      factory: 'Zavod',
      collectionPoint: 'Yig‘ish punkti',
      well: 'Quduq',
      field: 'Kon',
    },
  },
  optionPage: {
    title: 'Parametrlar',
    tabs: {
      statusBoard: 'Holatlar paneli',
      unknownTab: 'Nomaʼlum tab',
    },
    droppableStatusCard: {
      statuses: {
        working: 'Ish jarayoni',
        warning: 'Ogohlantirish',
        error: 'Kritik xato',
      },
      placeholder: 'Statusni bu yerga torting',
      saveButton: 'Saqlash',
      successMessage: 'Holatlar muvaffaqiyatli yangilandi!',
    },
  },
  menu: {
    production: 'Ishlab chiqarish',
    map: 'Xarita',
    model: 'Model',
    logs: 'Jurnallar',
    excelParse: 'Excel tahlili',
    nodes: 'Tugunlar',
    sensors: 'Sensorlar',
    users: 'Foydalanuvchilar',
    reports: 'Hisobotlar',
    notices: 'Bildirishnomalar',
    inspectionLog: 'Tekshiruv jurnali',
    options: 'Variantlar',
    responsibility: 'Mas’ul shaxslar',
    roles: 'Rollar',
    verification: 'Tekshirish jurnali',
    settings: 'Sozlamalar',
    licenses: 'Litsenziyalar',
    profile: 'Profil',
    state: 'Xolat',
  },
  responsibilitiesPage: {
    table: {
      profileName: 'Ism Familiya',
      node: 'Tugun',
      sensor: 'Sensor devEUI',
      updatedAt: 'Yangilangan sana',
      createdAt: 'Yaratilgan sana',
    },
    form: {
      selectNode: 'Tugunni tanlang',
      selectProfile: 'Profilni tanlang',
      selectSensor: 'Sensorni tanlang',
    },
  },
  rolesPage: {
    table: {
      name: 'Rol nomi',
      createdAt: 'Yaratilgan sana',
    },
    form: {
      namePlaceholder: 'Rol nomini kiriting',
    },
  },
  verificationPage: {
    table: {
      devEUI: "devEUI",
      serialNumber: "Seriya raqami",
      description: "Tavsif",
      verifiedAt: "Tekshiruv sanasi",
      status: "Tekshiruv muddati tugash sanasi",
      createdAt: "Yaratilgan sana",
    },
    form: {
      serialNumberPlaceholder: "Seriya raqami",
      verifiedAtPlaceholder: "Tekshiruv sanasi",
      descriptionPlaceholder: "Tavsif",
    },
    status: {
      expired: "Tekshiruv muddati tugadi",
      expiringSoon: "Tekshiruv muddati tez orada tugaydi",
      validUntil: "Amal qilish muddati {{date}} gacha",
    },
  },
  settingsPage: {
    chips: {
      save: "Saqlash",
      tableFilling: "Jadvallarni to'ldirish",
      selectTables: "Jadvallar ro'yxati",
      excelFieldOrder: "Excel maydonlari tartibi",
      addItemPlaceholder: "Element qo'shish",
      tableOrder: "Jadvallar tartibi",
    },
    tabs: {
      tables: "Jadvallar",
      parseExcel: "Excelni tahlil qilish",
      instantFlow: "Zudlik bilan",
    },
    messages: {
      requestSuccess: "So'rov muvaffaqiyatli bajarildi!",
    },
    tables: {
      node_closure: "Tugun bog'lanishi",
      snapshot: "Surat",
      migrations: "Ko'chirishlar",
      node: "Tugun",
      user_integration: "Foydalanuvchi integratsiyasi",
      sensor: "Sensor",
      fabricator: "Ishlab chiqaruvchi",
      model: "Model",
      user: "Foydalanuvchi",
      profile: "Profil",
      sensor_state: "Sensor holati",
      node_user: "Tugun-foydalanuvchi bog'lanuvi",
      role: "Rol",
      token: "Token",
      job: "Vazifa",
      option: "Variant",
      settings: "Sozlamalar",
      responsibility: "Mas'ul shaxslar",
      notice: "Bildirishnoma",
      sensor_packet: "Sensor paketi",
      seeder: "Ma'lumotlar bazasini to'ldiruvchi",
      event: "Hodisa",
      inspection_log: "Tekshiruv jurnali",
      verification: "Tekshiruv",
      translation: "Tarjima",
    },
  },
  licensesPage: {
    licenses: {
      downloadLicenseInfo: "Litsenziya ma'lumotlarini yuklab olish",
      dragOrClick: "Faylni shu yerga torting yoki tanlash uchun bosing",
      uploadSuccess: "Litsenziya muvaffaqiyatli yuklandi!",
      uploadFail: "Litsenziyani yuklash muvaffaqiyatsiz tugadi",
      error: "Xato: {{message}}",
    },
    crud: {
      cancel: "Bekor qilish",
      add: "Yuklash",
    },
  },
  crudTableView: {
    create: "Yaratish",
    update: "Yangilash",
    cancel: "Bekor qilish",
  },
  entity: {
    production: {
      singular: "Ishlab chiqarish",
      plural: "Ishlab chiqarishlar",
    },
    map: {
      singular: "Xarita",
      plural: "Xaritalar",
    },
    model: {
      singular: "Model",
      plural: "Modellar",
    },
    logs: {
      singular: "Log",
      plural: "Loglar",
    },
    excelParse: {
      singular: "Excel tahlili",
      plural: "Excel tahlillari",
    },
    hierarchy: {
      singular: "Ierarxiya",
      plural: "Ierarxiyalar",
    },
    sensors: {
      singular: "Datchik",
      plural: "Datchiklar",
    },
    users: {
      singular: "Foydalanuvchi",
      plural: "Foydalanuvchilar",
    },
    reports: {
      singular: "Hisobot",
      plural: "Hisobotlar",
    },
    notices: {
      singular: "Bildirishnoma",
      plural: "Bildirishnomalar",
    },
    inspectionLog: {
      singular: "Tekshiruv jurnali",
      plural: "Tekshiruv jurnallari",
    },
    options: {
      singular: "Variant",
      plural: "Variantlar",
    },
    responsibility: {
      singular: "Mas’ul shaxs",
      plural: "Mas’ul shaxslar",
    },
    roles: {
      singular: "Rol",
      plural: "Rollar",
    },
    verification: {
      singular: "Tekshiruv",
      plural: "Tekshiruvlar",
    },
    settings: {
      singular: "Sozlama",
      plural: "Sozlamalar",
    },
    licenses: {
      singular: "Litsenziya",
      plural: "Litsenziyalar",
    },
    profile: {
      singular: "Profil",
      plural: "Profillar",
    },
  },
  noPermissions: {
    title: 'Kirish cheklangan',
    message: 'Bu bo‘limni ko‘rish yoki ushbu harakatni bajarish uchun sizda yetarli huquqlar mavjud emas.',
    suggestion: 'Agar bu xato deb hisoblasangiz, tizim administratoriga yoki rahbaringizga murojaat qilib, kirish sozlamalarini aniqlashtiring.',
  },
  profilePage: {
    title: 'Profil',
    telegramId: 'Telegram ID',
    createdAt: 'Yaratilgan sana',
    updatedAt: 'Yangilangan sana',
    attachTelegram: 'Telegramni bog‘lash',
    confirmAttach: 'Telegramga akkauntni bog‘lashni tasdiqlang',
    cancel: 'Bekor qilish',
    apply: 'Tasdiqlash',
    unlink: 'Ajratish',
  },
  report: {
    title: "Hisobotlar",
    wellReportTitle: "Barcha quduqlar bo‘yicha hisobot",
    wellReportTitleAlt: "Barcha quduqlar hisoboti",
    download: "HISOBOTNI YUKLAB OLISH",
    table: {
      name: "Nomi",
      operationFactor: "Ishlash koeffitsienti",
      pipelinePressure: "Trubadagi bosim",
      wellPressure: "Quduqdagi bosim",
      type: "Turi",
      volume: "Hajm",
    },
  },
  personInfoModal: {
    title: "Mas'ul shaxs haqida ma'lumot",
    nameLabel: "To'liq ism",
    dobLabel: "Tug'ilgan sana",
    phoneLabel: "Telefon raqami",
  },
  sensorsSendCommand: {
    successRequest: "Muvaffaqiyatli so'rov!",
    parameters: "Parametrlar",
    enterValuesCommaSeparated: "Qiymatlarni vergul bilan ajratib kiriting",
    enterValue: "Qiymat kiriting",
    modelDoesNotSupportForm: "Model shaklni qo'llab-quvvatlamaydi",
    send: "Yuborish",
  },

}, 'uz')
